module.exports = __webpack_public_path__ + "static/product_header_left-b5601ecb88990655054ad7fb779724d0.png";